export default __webpack_public_path__ + "static/media/features_card1.03f14a78.svg";